/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SubscriberQuestionnaireItemDto } from './SubscriberQuestionnaireItemDto';

export type ManageMunicipalitySubscriberDto = {
    _id?: string;
    municipality: string;
    pnr: string;
    name?: string;
    email?: string;
    phoneNumber?: string;
    subscribe?: boolean;
    questionnaire: Array<SubscriberQuestionnaireItemDto>;
    language: ManageMunicipalitySubscriberDto.language;
    wantsToBeContacted?: boolean;
};

export namespace ManageMunicipalitySubscriberDto {

    export enum language {
        EN = 'en',
        SV = 'sv',
        DE = 'de',
        DA = 'da',
    }


}

